module.exports = __webpack_public_path__ + "media/remind-sound.a95c5c01.wav";